// extracted by mini-css-extract-plugin
export default {"innerWrapper":"St-z","tooltipWrapper":"Tt-z","icon":"Ut-z","tooltip":"Vt-z","content":"Wt-z"};